import React from 'react';
import './PublicLayout.scss';

const PublicLayout = ({ children }) => {
  return <div className="public-layout">{children}</div>;
};

export default PublicLayout;
